import SangjoPageLayout from "@/components/DefaultPageLayout";
import RefundCalculatorContainer from "@/containers/RefundCalculatorContainer/RefundCalculatorContainer";

import { Spacing } from "goi_common";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = () => {
  const title = "상조 해지 환급금 계산기 | 헤이상조";
  const description =
    "상조 해지 시 수령할 수 있는 예상 환급금을 알려드립니다. 손해보지 말고 정확한 상조 해지 환급금을 수령하세요. 납부 횟수를 기반으로 계산한 예상 환급금 계산기";
  const keywords =
    "상조 해지, 상조 해지 환급금, 상조 환급, 상조 환급금 계산기, 상조 해지 환급금 계산기, 내상조 찾아줘";

  return {
    props: {
      pageDescription: description,
      pageKeywords: keywords,
      pageOgTitle: title,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

const RefundCalculatorIndexPage = () => {
  return (
    <SangjoPageLayout title="상조 환급금 계산기">
      <Spacing gap={24} />
      <RefundCalculatorContainer />
    </SangjoPageLayout>
  );
};

export default RefundCalculatorIndexPage;
